import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { KpiCardComponent } from '@shared/components/kpi-card/kpi-card.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { CustomersKpiCardsStore } from './customers-kpi-cards.store';

@Component({
  imports: [KpiCardComponent, TranslateModule, NgxSkeletonLoaderModule],
  providers: [CustomersKpiCardsStore],
  selector: 'app-customers-kpi-cards',
  templateUrl: './customers-kpi-cards.component.html',
})
export class CustomersKpiCardsComponent {
  public readonly store = inject(CustomersKpiCardsStore);

  constructor() {
    this.store.fetchCustomersStats();
  }
}
